import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import actiondata from './actiondata'

const state = {
    data:{
        message:"",
        statuscode:undefined,
        showmessage:false,        
    }
    
    
};

export default {
  namespaced: true,
  modules: {
        actiondata: actiondata,
        
    },
  state,
  actions,
  getters,
  mutations,
};